const methods = [
    'get',
    'post',
    'put',
    'delete',
];

export default class FetchWP {
    constructor(options = {}) {
        this.options = options;

        if (!options.restURL)
            throw new Error('restURL option is required');

        if (!options.restNonce)
            throw new Error('restNonce option is required');

        methods.forEach(method => {
            this[method] = this._setup(method);
        });
    }

    updateQueryStringParameter(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        }
        else {
            return uri + separator + key + "=" + value;
        }
    }

    _setup(method) {
        return (endpoint = '/', data = false) => {
            let fetchObject = {
                credentials: 'same-origin',
                method: method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': this.options.restNonce,
                }
            };

            let baseUrl = this.options.restURL;
            let queryString = ''
            if (this.options.restURL.split("?").length > 1) {
                queryString = '?' + this.options.restURL.split("?")[1];
                baseUrl = this.options.restURL.split("?")[0];
            }
            let url = baseUrl + endpoint + queryString;

            if (data) {
                if (this.options.isMlActive) {
                    data.ml = this.options.ml;
                    data.isMlActive = this.options.isMlActive;
                }
                fetchObject.body = JSON.stringify(data);
            } else if (this.options.isMlActive) {
                url = this.updateQueryStringParameter(url, 'isMlActive', this.options.isMlActive)
                url = this.updateQueryStringParameter(url, 'ml', JSON.stringify(this.options.ml))
            }


            if (data) {
                fetchObject.body = JSON.stringify(data);
            }


            /*
            return fetch(url, fetchObject)
                .then(response => {
                    return response.json().then(json => {
                        return response.ok ? json : Promise.reject(json);
                    });
                });
           */

           return fetch(url, fetchObject)
           .then(response => {
               return response.text().then(txt => {
                   let json = {};
                   try {
                        json = JSON.parse(txt);
                   } catch(e) {
                      let  txts = txt.match(/(\{.*)/);
                      if(txts[0] !== undefined){
                          json = JSON.parse(txts[0]);
                      }
                   }

                   return response.ok ? json : Promise.reject(json);
               }).catch(()=>{

               });
           });





        }
    }
}
